/**
 * Gate 7 — Silent Prior Update
 *
 * Detects opinion drift without explicit Bayesian update artifact.
 * When a bayesianPriorRef is present in context, the output must
 * acknowledge that a prior exists and either confirm, update, or
 * explicitly hold it. Silent assumption of an updated position
 * without documenting the update is inadmissible.
 *
 * Trip routes to abstention with reason='silent_prior_update'.
 */

const BAYESIAN_UPDATE_MARKERS = [
  'updating', 'revised estimate', 'new evidence suggests', 'prior was',
  'posterior', 'given this new data', 'in light of', 'this changes my',
  'revising', 'prior belief', 'prior assessment', 'update my', 'updating my',
  'new information', 'prior estimate', 'bayesian', 'reweighting',
  'given new evidence', 'adjusting prior', 'prior probability',
  'this new data', 'this evidence changes',
];

/**
 * @param {import('../disciplineEnforcer.js').EnforcerEnvelope} envelope
 * @param {object} [_config]
 * @returns {import('../disciplineEnforcer.js').GateResult}
 */
export function checkSilentPriorUpdate(envelope, _config = {}) {
  const bayesianPriorRef = envelope.context?.bayesianPriorRef;

  if (!bayesianPriorRef) {
    return { gateName: 'silent_prior_update', verdict: 'pass', reason: null, payload: { priorRefPresent: false } };
  }

  const text = (envelope.rawOutput || '').toLowerCase();
  const hasUpdateMarker = BAYESIAN_UPDATE_MARKERS.some(m => text.includes(m));

  if (!hasUpdateMarker) {
    return {
      gateName: 'silent_prior_update',
      verdict: 'trip',
      reason: 'silent_prior_update',
      payload: { bayesianPriorRef, updateMarkerFound: false },
    };
  }

  return {
    gateName: 'silent_prior_update',
    verdict: 'pass',
    reason: null,
    payload: { bayesianPriorRef, updateMarkerFound: true },
  };
}
